require('./angulartics-segment')
module.exports = 'angulartics.segment'
